import React, { useMemo } from "react";
import { FormGroup, Button } from "reactstrap";
import CasesApi from "../../api/CasesApi";
import fetchApi from "../../util/fetchApi";
import { interpolate } from "../../util/mapObject";
import useResourceLoader from "../../util/useResourceLoader";
import { useSideChannelSubscription } from "../../util/useSideChannel";


function CaseZipDownloadField(props) {
    const {
        formContext,
        schema: {
            title,
            filter
        },
        uiSchema: {
            'ui:readonly': readonly
        },
    } = props;
    const { sideChannel } = formContext;

    const formObject = useSideChannelSubscription(sideChannel, 1) || [{}];

    const [url] = useResourceLoader(() => (formObject && formObject.id) ? CasesApi.getCaseZipDownloadUrl({
        caseId: formObject.id, filter
    }) : null, [
        (formObject || {}).id, filter
    ]);

    console.log("url", url);

    return (
        <FormGroup className="file-field" disabled={readonly}><Button
            className="btn-block"
            href={url}
            target="_blank"
        >{title}</Button></FormGroup>
    );
}


export default CaseZipDownloadField;